import { useState, useEffect } from 'react';
import Layout from '../components/Layout';

export default function Adminv1() {
  const [domains, setDomains] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newDomain, setNewDomain] = useState('');
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const API_BASE = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/domains`, {
      credentials: 'include',
    })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => setDomains(data))
      .catch(err => console.error('Failed to fetch domains:', err));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = newDomain.trim();
    if (!trimmed) {
      setError('Domain name is required');
      return;
    }
    if (!/^https?:\/\/.+/.test(trimmed)) {
      setError('URL must start with http:// or https://');
      return;
    }

    fetch(`${API_BASE}/api/v1/domains`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ name: trimmed, status: 'New' }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.error || 'Failed to save domain');
        }
        return res.json();
      })
      .then(() => {
        return fetch(`${API_BASE}/api/v1/domains`, {
          credentials: 'include',
        }).then(res => res.json());
      })
      .then(data => {
        setDomains(data);
        setNewDomain('');
        setShowModal(false);
        setError('');
      })
      .catch((err) => {
        setError(err.message || 'Failed to save domain');
      });
  };
  const filteredDomains = domains.filter(domain =>
    domain.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <Layout  onSearch={setSearchTerm}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Domains V-1</h2>
        <button className="btn btn-primary" onClick={() => {
          setNewDomain('');
          setError('');
          setShowModal(true);
        }}>Add New Domain</button>
      </div>

      <table className="table table-striped">
        <thead>
          <tr>
            <th>Domain</th>
            <th>Status</th>
            <th>Added Date</th>
          </tr>
        </thead>
        <tbody>
                  {filteredDomains.map((domain, index) => (
            <tr key={index}>
              <td>{domain.name}</td>
              <td>
              <span
                className={`badge bg-${
                  domain.status === 'Active'
                    ? 'success'
                    : domain.status === 'New'
                    ? 'warning'
                    : 'danger'
                }`}
              >
                  {domain.status}
                </span>
              </td>
              <td>{new Date(domain.created_at).toLocaleDateString('uk-UA')}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">Add Domain</h5>
                  <button type="button" className="btn-close" onClick={() => {
                    setShowModal(false);
                    setNewDomain('');
                    setError('');
                  }}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label htmlFor="domain" className="form-label">Domain Name</label>
                    <input
                      type="text"
                      id="domain"
                      className={`form-control ${error ? 'is-invalid' : ''}`}
                      value={newDomain}
                      onChange={(e) => setNewDomain(e.target.value)}
                    />
                    {error && <div className="invalid-feedback">{error}</div>}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => {
                    setShowModal(false);
                    setNewDomain('');
                    setError('');
                  }}>Close</button>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
